import * as types from "./types";

export const defaultState = {
  commitments: {},
  loading: false,
  errors: []   
};

const commitments = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCHED_COMMITMENT:    
      let existent_commitments = {...state.commitments};       
      existent_commitments[action.circleId] = action.commitments;
      return {
        ...state,
        commitments: existent_commitments,
        loading: action.loading        
      }
    case types.SIGNED_COMMITMENT:    
      existent_commitments = {...state.commitments}; 
      let circle_commitments = [];      
      if(existent_commitments[action.circleId]){
        circle_commitments = existent_commitments[action.circleId];
      }
      const commitments = [...circle_commitments, action.commitment];
      return {
        ...state,
        commitments: { ...existent_commitments, [action.circleId]: commitments },
        loading: action.loading        
      } 
    case types.FETCHING_COMMITMENT:       
    case types.SIGNING_COMMITMENT:       
      return {
        ...state,
        loading: action.loading
      }     
    case types.ERROR_FETCHING_COMMITMENT:        
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: action.loading
      }
    default:
      return state;
  }
};
export default commitments;
